import { PureConnect, React } from '../../react';
import { hack } from '../../browser/launch';
import { INote, INoteChat, INoteShared, IQuestionDB, isSharedNote } from '../../types';
import { notechatEditor, notechatResource } from './resource';
import cx from './style.less';
import { DataListChat } from './notechatdatalist/datalistchat';
import adminReselectors from '../admin/reselectors';
import { Btn } from '../../react-toolbox-redesign/button';
import { notesEditor } from '../notes/resource';
import START_CHAT from '../notes/actions/START_CHAT';
import { ChainedChat } from './notechatdatalist/dataitemchat';
import selectorsParticipantPopup from '../noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../categorySelectPopup/selectors';
import notesSelector from '../notes/selectors';
import { notesSharedEditor } from '../noteshared/resource';
import { canChangeQuestion, statusNieuw, statusses } from '../question/authmodule/authcheck';
import { questionsResource } from '../question/resource';
import { useridResource } from '../../participantid/resource';
import { beheerResource } from '../../admin/resource';
 
export default PureConnect(`NoteChatCreateControl`)(
    (state) => ({
        updating: notechatEditor.selectors.updating(state),    
        noteChats: notechatResource.selectors.items(state),
        participants: adminReselectors.participantsSelector(state),  
        itemNote: notesEditor.selectors.item(state) as INote,
        itemSharedNote: notesSharedEditor.selectors.item(state) as INoteShared, 
        inspect: notesSelector.inspect(state) as INote,
        creatingNote: notesEditor.selectors.creating(state),
        updatingNote: notesEditor.selectors.updating(state),        
        selectNote: state.selection.creating,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        selectTextArea: state.selection.creating, 
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({ 

    }),
    ({ flyoverVisible, itemNote, itemSharedNote, inspect, updating, participants, noteChats, creatingNote, updatingNote, selectNote, participantPopupVisible, categoryPopupVisible, selectTextArea }) => {

        var note = itemSharedNote && isSharedNote(itemSharedNote)? itemSharedNote: itemNote;
        var visible=(!updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea);
        var noteselection = flyoverVisible ? note: inspect;
        return (              
                <div aria-labelledby= "Geef notitie reactie" className={cx('notechat-dit-list-container', visible ? '': 'wcag-invisible', flyoverVisible ? 'flyover-chat': 'modal-chat')}>
                        <span className={cx('input-label')}>Reacties</span>
                        <ChainedChat noteId={noteselection.id}/>
                        <NoteChatCreate noteId={noteselection.id}/>
                        <DataListChat items={noteChats}
                                    flyoverVisible={flyoverVisible} 
                                    participants={participants}
                                    noteId={noteselection.id} />
                </div>         
        );
});

export const NoteChatCreate = PureConnect<{noteId: number}>(`NoteChatCreate`)(
    (state) => ({
        participants: adminReselectors.participantsSelector(state),  
        creating: notechatEditor.selectors.creating(state),
        item: notechatEditor.selectors.item(state),
        updating: notechatEditor.selectors.updating(state),      
        origin: state.notemenu.origin,
        flyoverVisible: state.flyover.visible,
        inspect: notesSelector.inspect(state) as INote,
        // note: notesEditor.selectors.item(state) as INote,      
        itemNote: notesEditor.selectors.item(state) as INote,
        itemSharedNote: notesSharedEditor.selectors.item(state) as INoteShared,  
        questions: questionsResource.selectors.items(state),
        currentUser: useridResource.selectors.items(state),
        usergroups: adminReselectors.usergroupSelector(state),   
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch) => ({ 
        cancel: () => dispatch(notechatEditor.actions.RESET({ })),
        change: (item: INoteChat) => { dispatch(notechatEditor.actions.APPLY({ item }));},
        saveCreating: (item: INoteChat, note: INote) => { 
            item = fixNoteDevelopmentJsonServer(item, note, true);
            dispatch(notechatEditor.actions.CREATE_CONTINUE({ item }));             
        },
        deleteUsergroup: (item: INoteChat) => dispatch(notechatEditor.actions.DELETE({ item })),
        startChat:(note: INote) => dispatch(START_CHAT( {item: note} )),
    }),
    ({ flyoverVisible, itemSharedNote, itemNote, inspect, questions, creating, currentUser, item, usergroups, beheer, saveCreating, startChat, change }) => {
        var note = itemSharedNote && isSharedNote(itemSharedNote)? itemSharedNote: itemNote;
        const maxNoteTextLength=3000;
        var noteselection = flyoverVisible ? note: inspect;
        if (creating) item.text = !item.text ? '': 
            item.text.length >= maxNoteTextLength ? item.text.substring(0, maxNoteTextLength-1) : item.text; 

        var canChange = true;
        var itemQuestion = null;
        var status= statusNieuw;
        if (note.isquestion) {
            itemQuestion = questions.qFirst((o: IQuestionDB) => o.noteId === note.id) as IQuestionDB;
            var currentUserId =  currentUser.length > 0 ? currentUser[0].id : '';
            var admin = beheer && beheer.qAny() && beheer.qFirst();
            status = !!itemQuestion && itemQuestion.status ? itemQuestion.status: statusNieuw;
            canChange = canChangeQuestion(statusses, status, currentUserId, usergroups, admin);
        }

        return (              
                <div aria-labelledby= "Geef notitie reactie">
                        <div className={cx('notechat-container')}>
                        <div className={cx('input-text-chat')}>                                
                                <textarea 
                                    disabled ={!canChange}
                                    className={cx('input-text-chat-area')} 
                                    placeholder="Type hier uw reactie..." 
                                    name="q" 
                                    ref="term" 
                                    aria-multiline
                                    value={item.text || ''} 
                                    onFocus={(itm) => {startChat(noteselection);} }                      
                                    onChange={(x) => {
                                        item.text=x.target.value;
                                        change(item);                                        
                                    }} />

                                <Btn
                                    type="button"
                                    className={'btn'} 
                                    extraClassNames={[cx('span-button-icon-send'), 'icon-btn', 'icon-send']}                                                                         
                                    aria-label={'Opslaan'}
                                    aria-haspopup={false}
                                    tabIndex={item.text ? 0 : -1}
                                    disabled={!item.text}
                                    onKeyDown={(evt: any) => {
                                        handleEnters(evt, 
                                            () => saveCreating(item, noteselection));
                                    }}
                                    onClick={() => saveCreating(item, noteselection) }
                                >
                                    <span></span>
                                </Btn>                    
                            </div>                   
                        </div>
                </div>         
        );
});

function handleEnters(evt: any, funct: ()=>void) {
    if (evt.key==='Enter') {evt.preventDefault(); funct();}
}   

function fixNoteDevelopmentJsonServer(item: INoteChat, note: INote, create: boolean) {

    return item;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notechat/editChat.tsx